import * as ewe from "@eyeo/webext-ad-filtering-solution";
import ServerMessages from "~/servermessages";
import { port } from "../../../adblockplusui/adblockpluschrome/lib/messaging/port";
import { messageIdentifier } from "../shared";
import { start as startCookieBannerExperiment } from "./cookie-banner";
import { experimentFlag as cookieBannerExperimentFlag } from "./cookie-banner.types";
function sendEvent({ name }) {
    ServerMessages.recordGeneralMessage(name);
}
export async function start() {
    ext.addTrustedMessageTypes(null, [messageIdentifier]);
    port.on(messageIdentifier, sendEvent);
    const cookieBannerFlag = await ewe.experiments.getFlag(cookieBannerExperimentFlag);
    if (cookieBannerFlag === true) {
        startCookieBannerExperiment();
    }
}
